import { useState } from "react";

const useForm = <T extends Record<string, any>>(initialState: T) => {
    const [form, setForm] = useState<T>(initialState);
    const [params, setParams] = useState(initialState);
    const [file, setFile] = useState<File | null>(null);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value, type } = event.target;
        if (type === "file" && event.target instanceof HTMLInputElement) {
            if (event.target.files && event.target.files[0]) {
                setFile(event.target.files[0]);
            }
        } else {
            setForm({ ...form, [name]: value });
        }
    };

    const updateParams = () => {
        setParams(form);
    }

    return {
        form,
        params,
        file,
        handleChange,
        setForm,
        setFile,
        updateParams
    };
};

export default useForm;